<template>
  <div class="home-container">
    <v-sidebar @login="(type) => vLoginRefs.show(type)" />
    <div class="wrapper">
      <div class="banner" v-if="$event.Banner">
        <img :src="$event.Banner" />
      </div>
      <div class="event-body">
        <h3 class="event-title" v-if="!($event?.Config?.HideEventName===true)">{{ $event.EventName }}</h3>
        <v-contact :share="false" />
        <article v-html="$event.Remark"></article>
        <div class="share">
          <div class="share-title">
            <el-icon><em-icon-share /></el-icon>
            <span>{{ $t('index.share') }}</span>
          </div>
          <v-share />
        </div>
      </div>
      <el-affix class="affix-toolbar" position="bottom" :offset="0">
        <div class="toolbar">
          <el-button v-if="!$event.EventName.includes('远毅')" type="primary" class="confirmation" @click="vLoginRefs.show()">{{ $t('index.confirmation') }}</el-button>
          <el-button v-if="$event.IsClose" type="primary" :disabled="true" >{{["报名截止", "Ended"][$language] }}</el-button>
          <el-button v-else type="primary" class="register" @click="vLoginRefs.show()">{{ $t('index.register') }}</el-button> 
        </div>
      </el-affix>
    </div>

    <v-login ref="vLoginRefs" />
  </div>
</template>

<script setup>
  import VSidebar from './sidebar.vue'
  import VContact from './contact.vue'
  import VShare from './share.vue'
  import VLogin from '../../login/index.vue'
  import { ref, inject } from 'vue'

  import { useAppStore } from '@/store/modules/app'
  import { storeToRefs } from 'pinia'

  const { template, mobile } = storeToRefs(useAppStore())

  const $event = inject('$event')
  const $language = inject("$language"); 
  //
  const vLoginRefs = ref(null)
</script>

<style lang="scss" scoped>
  .home-container {
    width: 100%;
    min-height: 100vh;
    max-width: 1000px;
    margin: 0 auto 0 auto;
    color: #333333;
    border-radius: 0 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 12px;
    .sidebar {
      flex: 0 0 340px;
    }
    .wrapper {
      flex: 1;
      margin-top: 68px;
      margin-left: 1px;
      .banner {
        border-radius: 0 12px 0 0;
        background: rgba(255, 255, 255, 0.93);
        overflow: hidden;
        display: block;
        img {
          width: 100%;
        }
      }
      .event-body {
        background: rgba(255, 255, 255, 0.93);
        padding: 20px 28px 20px 28px;
        margin-bottom: 20px;
        h3 {
          &.event-title {
            font-style: normal;
            font-weight: bold;
            font-size: 26px;
            line-height: 36px;
            text-align: center;
            padding: 0 0 20px 0;
            margin: 0;
          }
        }
        article {
          :deep() {
            p {
              margin-bottom: 12px;
              font-size: 14px;
              line-height: 24px;
              &:last-child {
                margin-bottom: 0;
              }
              img {
                width: 100%;
                max-width: 600px;
                height: auto;
              }
            }
            table {
              max-width: 100%;
            }
          }
        }
        .contact,
        .share {
          display: none;
        }
      }
      .affix-toolbar {
        display: none;
      }
    }
  }
  @media screen and (max-width: 750px) {
    .home-container {
      width: 100%;
      max-width: 750px;
      margin: 0 auto 0 auto;
      padding: 0;
      .sidebar {
        display: none;
      }
      .wrapper {
        flex: 1;
        width: 100%;
        margin-top: 0;
        .banner {
          border-radius: 0 0 0 0;
        }
        .event-body {
          padding: 20px 20px;
          background: rgba(255, 255, 255, 0.93);
          article {
            font-size: 14px;
            margin: 20px 0;
            :deep() {
              img {
                max-width: 100%;
                height: auto;
              }
            }
          }
          .contact,
          .share {
            display: block;
          }
          .sidebar {
            display: none;
          }
        }
        .contact {
          background: rgba(238, 242, 248, 0.68);
          border-radius: 10px;
          padding: 12px;
          display: block;
          :deep() {
            .row {
              margin-bottom: 0px;
              &:last-child {
                margin-bottom: 0;
              }
              .label-text {
                .label {
                  font-weight: bold;
                  color: var(--el-color-primary);
                  font-size: 14px;
                }
                .text {
                  color: rgba(54, 63, 94, 0.5);
                  font-size: 12px;
                }
              }
            }
          }
        }
        .affix-toolbar {
          display: block;
        }
      }

      .share {
        background: rgba(238, 242, 248, 0.66);
        border-radius: 10px;
        padding: 10px;
        &-title {
          margin-bottom: 10px;
          line-height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            font-weight: bold;
            margin-left: 3px;
            color: var(--el-color-primary);
            font-size: 14px;
          }
        }
        svg {
          :deep() {
            path {
              fill: var(--el-color-primary);
              fill-opacity: 0.8;
            }
          }
        }
      }
      .toolbar {
        background-color: #fff; //var(--el-color-primary-light-5);// #5573ed; // var(--el-color-primary-light-7);
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 20px;
        border-top: solid 1px rgba(238, 242, 248, 0.68);
        .el-button {
          width: calc(50% - 6px);
          margin: 0;
          height: 40px;
          &.confirmation {
            width: calc(30% - 6px);
            min-width: 80px;
            //background-color: var(--el-color-primary-light-2);
            //border-color: var(--el-color-primary-light-2);
          }
          &.register {
            width: calc(70% - 6px);
            font-size: 18px;
            max-width: calc( 100% - 80px - 12px);
          }
        }
      }
    }
  }
</style>
